import { render, staticRenderFns } from "./PageAuth.vue?vue&type=template&id=40ad68ec&scoped=true"
import script from "./PageAuth.vue?vue&type=script&lang=js"
export * from "./PageAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_255d5a8a54575e72ac5a6ee47e553c82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ad68ec",
  null
  
)

export default component.exports